import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Star, Phone } from 'lucide-react';
export function Hero() {
  const [showCopied, setShowCopied] = useState(false);
  const handlePhoneClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire Google Ads conversion event
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('event', 'conversion', {
        send_to: 'AW-349742034/M8ECCPrSnrADENLH4qYB'
      });
    }
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
      e.preventDefault();
      const phoneNumber = '(818) 381-9905';
      navigator.clipboard.writeText(phoneNumber).then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      }).catch(() => {
        window.location.href = 'tel:8183819905';
      });
    }
  };
  return <section id="home" className="relative w-full min-h-[80vh] flex flex-col items-center justify-center bg-black overflow-hidden px-4 py-20 pt-32" data-id="element-79">
      {/* Background ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-white/5 rounded-full blur-[100px] pointer-events-none" data-id="element-80" />

      {/* Logo Container */}
      <div className="relative z-10 mb-12" data-id="element-81">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative" style={{
        mixBlendMode: 'lighten'
      }} data-id="element-82">
          <img src="https://cdn.magicpatterns.com/uploads/cLkq5sUtoNy1UGX3WoA69D/Possible_New_Logo_Look_Mikes_Pro_Detail_.png" alt="Mike's Pro Detail - Professional Mobile Auto Detailing Service in Los Angeles and Ventura County" className="w-full max-w-[400px] md:max-w-[600px] h-auto drop-shadow-2xl" data-id="element-83" />

          {/* Animated Sparkles overlaying the logo area */}
          <Sparkle className="absolute top-[20%] left-[10%] w-6 h-6 text-white" delay={0.5} data-id="element-84" />
          <Sparkle className="absolute top-[15%] right-[15%] w-8 h-8 text-white" delay={1.2} data-id="element-85" />
          <Sparkle className="absolute bottom-[30%] left-[5%] w-4 h-4 text-blue-400" delay={2.0} data-id="element-86" />
        </motion.div>
      </div>

      {/* Phone Number - Right below logo */}
      <motion.a href="tel:8183819905" onClick={handlePhoneClick} initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.5
    }} className="relative z-10 inline-flex items-center gap-3 mb-6 text-3xl md:text-5xl lg:text-6xl font-black text-white tracking-tighter hover:scale-105 transition-transform cursor-pointer" aria-label="Call Mike's Pro Detail" data-id="element-87">
        <Phone className="w-8 h-8 md:w-12 md:h-12 text-red-500 fill-red-500/20" data-id="element-88" />
        (818) 381-9905
      </motion.a>

      {/* Text Content */}
      <div className="relative z-10 text-center space-y-6" data-id="element-89">
        <motion.h1 initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="text-4xl md:text-6xl font-black tracking-tighter uppercase" data-id="element-90">
          <span className="bg-clip-text text-transparent bg-gradient-to-b from-white via-gray-200 to-gray-500 drop-shadow-lg font-['DM_Sans',_sans-serif]" data-id="element-91">
            Mobile Auto Detailing
          </span>
          <br data-id="element-92" />
          <span className="inline-block mt-12 px-1 bg-clip-text text-transparent bg-gradient-to-b from-white via-gray-200 to-gray-500 drop-shadow-lg md:text-5xl text-[60px] font-['DM_Sans',_sans-serif]" data-id="element-93">
            Ventura County
          </span>
          <br data-id="element-94" />
          <span className="inline-block mt-2 bg-clip-text text-transparent bg-gradient-to-b from-white via-gray-200 to-gray-500 drop-shadow-lg md:text-4xl text-[48px]" data-id="element-95">
            &amp;
          </span>
          <br data-id="element-96" />
          <span className="inline-block mt-2 bg-clip-text text-transparent bg-gradient-to-b from-white via-gray-200 to-gray-500 drop-shadow-lg md:text-5xl text-[56px] font-['DM_Sans',_sans-serif]" data-id="element-97">
            San Fernando Valley
          </span>
        </motion.h1>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="flex flex-col items-center gap-4" data-id="element-98">
          <p className="text-xl md:text-2xl font-bold text-yellow-400 tracking-widest uppercase drop-shadow-md text-center" data-id="element-99">
            Professional Mobile Car Detailing
            <br data-id="element-100" />
            We Come to You
          </p>

          <a href="#contact" className="mt-8 px-8 py-4 bg-gradient-to-r from-red-600 to-red-800 text-white font-bold text-lg uppercase tracking-wider rounded-sm hover:from-red-500 hover:to-red-700 transition-all shadow-[0_0_20px_rgba(220,38,38,0.5)] hover:shadow-[0_0_30px_rgba(220,38,38,0.8)]" data-id="element-101">
            Book Now
          </a>
        </motion.div>
      </div>

      {/* Copied to clipboard toast */}
      {showCopied && <div className="fixed top-8 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-3 bg-green-600 text-white rounded-lg shadow-lg animate-in fade-in slide-in-from-top-2 duration-300" data-id="element-102">
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-103">
            <polyline points="20 6 9 17 4 12" data-id="element-104"></polyline>
          </svg>
          <span className="font-semibold" data-id="element-105">
            Phone number copied to clipboard!
          </span>
        </div>}
    </section>;
}
function Sparkle({
  className,
  delay
}: {
  className?: string;
  delay: number;
}) {
  return <motion.div initial={{
    scale: 0,
    opacity: 0,
    rotate: 0
  }} animate={{
    scale: [0, 1, 0],
    opacity: [0, 1, 0],
    rotate: [0, 90, 180]
  }} transition={{
    duration: 2,
    repeat: Infinity,
    repeatDelay: 3,
    delay: delay,
    ease: 'easeInOut'
  }} className={className} data-id="element-106">
      <Star fill="currentColor" className="w-full h-full" data-id="element-107" />
    </motion.div>;
}